import { JUNGNA_TABLES } from "./jungnaTables";
import { supabase } from "./supabaseClient";

export interface ResolvedProductBank {
  id: string;
  name: string;
  account_number: string;
  is_active: boolean;
  user_id: string | null;
}

interface ProductOwnerRow {
  user_id: string | null;
}

interface ProductBankMappingRow {
  bank_id: string | null;
}

const bankSelect = "id, name, account_number, is_active, user_id";

const getActiveBankById = async (bankId: string): Promise<ResolvedProductBank | null> => {
  const { data, error } = await supabase
    .from(JUNGNA_TABLES.banks)
    .select(bankSelect)
    .eq("id", bankId)
    .eq("is_active", true)
    .maybeSingle<ResolvedProductBank>();

  if (error) throw error;
  return data ?? null;
};

const getActiveBankByUser = async (userId: string | null): Promise<ResolvedProductBank | null> => {
  if (!userId) return null;

  const { data, error } = await supabase
    .from(JUNGNA_TABLES.banks)
    .select(bankSelect)
    .eq("user_id", userId)
    .eq("is_active", true)
    .order("created_at", { ascending: false })
    .limit(1)
    .maybeSingle<ResolvedProductBank>();

  if (error) throw error;
  return data ?? null;
};

export const resolveProductBank = async (productId: string): Promise<ResolvedProductBank | null> => {
  const { data: product, error: productError } = await supabase
    .from(JUNGNA_TABLES.products)
    .select("user_id")
    .eq("id", productId)
    .maybeSingle<ProductOwnerRow>();

  if (productError) throw productError;

  const { data: mapping, error: mappingError } = await supabase
    .from(JUNGNA_TABLES.urlMappings)
    .select("bank_id")
    .eq("product_id", productId)
    .eq("is_active", true)
    .order("created_at", { ascending: false })
    .limit(1)
    .maybeSingle<ProductBankMappingRow>();

  if (mappingError) throw mappingError;

  if (mapping?.bank_id) {
    const mappedBank = await getActiveBankById(mapping.bank_id);
    if (mappedBank) return mappedBank;
  }

  return getActiveBankByUser(product?.user_id ?? null);
};
